<template>
    <div class="diagram">
        <div class="choose row-center">
            <div class="select">
                <div class="column-center">
                    <div class="tit" :class="{activeTitle: currentType === 0}" @click="showList = !showList">
                        环比 [{{dates[currentDate]}}<img src="../assets/img/arrow.png">]
                    </div>
                </div>
                <div class="date" v-if="showList">
                    <div @click="onchange(index), currentType = 0, showList = false" v-for="(item, index) in dates" :key="index"
                        :class="{active: index === currentDate && currentType === 0}">
                        {{item}}
                    </div>
                </div>
            </div>
            <div class="tit" @click="consistent(), currentType = 1, showList = false" :class="{activeTitle: currentType === 1}">年同比</div>
        </div>
        <div id="chart"></div>
    </div>

</template>

<script>
    export default {
        name: "Chart",
        props: {
            data: Array,
            unit: String,
        },
        data() {
            return {
                currentType: 0,
                myChart: null,
                currentDate: 0,
                dates: ['日', '月'],
                showList: false,
            }
        },
        methods: {

            initEcharts() {
                let echarts = require("echarts");
                // 基于准备好的dom，初始化echarts实例
                var myChart = echarts.init(document.getElementById("chart"));
                this.myChart = myChart

                window.addEventListener("resize", this.resize);
            },
            onchange(i) {
                this.currentDate = i

                this.$emit("onchange", {
                    type: '环比',
                    range: this.dates[i]
                })
            },
            consistent() {
                this.$emit("onchange", {
                    type: '同比',
                    range: '年'
                })
            },
            resize() {
                this.myChart.resize();
            }
        },

        // beforeMount() {
        //     this.getData()
        // }
        mounted() {
            this.initEcharts();

            this.$emit("onchange", {
                type: '环比',
                range: this.dates[this.currentDate]
            })
        },
        updated() {
            this.myChart.setOption({
                grid: {
                    left: 80,
                    right: 80,
                    bottom: "20px",
                    // containLabel: true,
                },
                legend: {
                    icon: "roundRect",
                    right: "5%",
                    top: 0,
                    itemWidth: 12,
                    itemHeight: 12,
                    itemGap: 20,
                    textStyle: {
                        color: "#fff",
                        fontSize: 14,
                    },
                },
                xAxis: {
                    type: "category",
                    name: "时间",
                    nameTextStyle: {
                        fontSize: 14,
                        color: "#e6f3fd",
                    },
                    axisTick: {
                        show: false,
                    },
                    boundaryGap: [0, "100%"],
                    axisLabel: {
                        color: "#fff",
                        textStyle: {
                            fontSize: 14,
                        },
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#fff",
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    name: "电能(kW·h)",
                    nameTextStyle: {
                        fontSize: 14,
                        color: "#fff",
                        bottom: 40,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#fff",
                        textStyle: {
                            fontSize: 14,
                        },
                    },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: "#ccc",
                            type: "dashed",
                        },
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#D2D2D2",
                        },
                    },
                },
                series: [{
                        type: "bar",
                        data: [this.data ? this.data[0] : 10],
                        barMaxWidth: 50,
                        itemStyle: {
                            normal: {
                                color: "#5AD8A6",
                                label: {
                                    show: true,
                                    position: "top",
                                    fontSize: 18,
                                    color: "#5AD8A6",
                                },
                            },
                        },
                    },
                    {
                        type: "bar",
                        data: [this.data ? this.data[1] : 50],
                        barMaxWidth: 50,
                        itemStyle: {
                            normal: {
                                color: "#0D94FF",
                                label: {
                                    show: true,
                                    position: "top",
                                    fontSize: 18,
                                    color: "#0D94FF",
                                },
                            },
                        },
                    },
                ],
            });
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.resize);
        },

        watch: {
            data(n, o) {
                let title1 = ""
                let title2 = ""

                if (this.currentType === 1) {
                    title1 = "去年"
                    title2 = "今年"
                } else {
                    if (this.currentDate === 0) {
                        title1 = "昨天"
                        title2 = "今天"
                    } else {
                        title1 = "上月"
                        title2 = "本月"
                    }
                }

                // 绘制图表
                this.myChart.setOption({
                    grid: {
                        left: 80,
                        right: 80,
                        bottom: "20px",
                        // containLabel: true,
                    },
                    legend: {
                        icon: "roundRect",
                        right: "5%",
                        top: 0,
                        itemWidth: 12,
                        itemHeight: 12,
                        itemGap: 20,
                        textStyle: {
                            color: "#fff",
                            fontSize: 14,
                        },
                    },
                    xAxis: {
                        type: "category",
                        name: "时间",
                        nameTextStyle: {
                            fontSize: 14,
                            color: "#e6f3fd",
                        },
                        axisTick: {
                            show: false,
                        },
                        boundaryGap: [0, "100%"],
                        axisLabel: {
                            color: "#fff",
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#fff",
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        name: "电能(kW·h)",
                        nameTextStyle: {
                            fontSize: 14,
                            color: "#fff",
                            bottom: 40,
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            color: "#fff",
                            textStyle: {
                                fontSize: 14,
                            },
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: "#ccc",
                                type: "dashed",
                            },
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: "#D2D2D2",
                            },
                        },
                    },
                    series: [{
                            name: title1,
                            type: "bar",
                            data: [n ? n[0] : 10],
                            barMaxWidth: 50,
                            itemStyle: {
                                normal: {
                                    color: "#5AD8A6",
                                    label: {
                                        show: true,
                                        position: "top",
                                        fontSize: 18,
                                        color: "#5AD8A6",
                                    },
                                },
                            },
                        },
                        {
                            name: title2,
                            type: "bar",
                            data: [n ? n[1] : 50],
                            barMaxWidth: 50,
                            itemStyle: {
                                normal: {
                                    color: "#0D94FF",
                                    label: {
                                        show: true,
                                        position: "top",
                                        fontSize: 18,
                                        color: "#0D94FF",
                                    },
                                },
                            },
                        },
                    ],
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    @h: 15%;
    @h2: 85%;

    .active {
        color: #0d94ff;
    }

    .tit {
        opacity: 0.5;
        cursor: pointer;
    }

    .activeTitle {
        opacity: 1;
    }

    .diagram {
        width: 100%;
        height: 100%;

        .choose {
            width: 100%;
            height: @h;
            max-height: @h;
            font-size: 18rem;
            color: #E6F3FD;

            img {
                margin: 0 6px;
            }

            >div {
                margin: 0 27px;
            }

            .select {
                position: relative;
                height: 100%;

                >div:first-child {
                    height: 100%;
                }

                .date {
                    width: 100%;
                    position: relative;
                    left: 0;
                    top: 0;
                    background-color: #030D18;
                    padding: 5px 8px;
                    max-height: 100vh;
                    display: block;
                    overflow: hidden;
                    z-index: 999;
                    cursor: pointer;

                    div {
                        text-align: center;
                        margin-bottom: 11px;
                        padding-top: 11px;
                        opacity: 0.75;

                        &:not(:first-child) {
                            border-top: 1px solid rgba(255, 255, 255, 0.15);
                        }

                        &:hover {
                            color: #0d94ff;
                        }
                    }
                }
            }
        }

        #chart {
            width: 100%;
            height: @h2;
        }
    }
</style>